import TransferSampleUnitsModal from './TransferSampleUnitsModal'

export default TransferSampleUnitsModal
